import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "scaffold";
export var SCAFFOLD_CONSTANTS = {
    elementName: elementName
};
